// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1tBGn","title":"FrontImage_title__3g3yW"};